module.exports = __webpack_public_path__ + "img/img-card-1.499682d.webp";